<template>
    <div>
        <b-container>
          <b-button :to="{ name: 'Home'}" variant="primary" class="mb-2">Voltar</b-button>

          <b-card title="Pacientes">
            <b-input v-model="nomepaciente" @keyup="pesquisa"/>

            <b-table-simple>
              <b-thead>
                <b-tr>
                  <b-th>
                    Nome
                  </b-th>
                </b-tr>
               </b-thead>
                <b-tbody>
                    <b-tr v-for="(item, index) in pacientes" :key="index" @click="ficha(item.cz04_nrop)">
                      <b-td>
                        {{item.cz04_nome}}
                      </b-td>
                    </b-tr>
                 </b-tbody>
            </b-table-simple>
          </b-card>
        </b-container>
    </div>
</template>

<script>
import Pacientes from '../services/PacienteService'

export default {
  name: 'pacientes',
  data () {
    return {
      pacientes: [],
      nomepaciente: ''
    }
  },
  created () {
    this.pesquisa()
  },
  methods: {
    pesquisa () {
      if (this.nomepaciente.length >= 3) {
        let pesquisa = {}
        const obj = JSON.parse(localStorage.usuarioMC)

        if (obj.empresa !== undefined) {
          pesquisa.empresa = JSON.stringify(obj.empresa)
        }
        if (obj.usuario.cz08_crem !== undefined) {
          pesquisa.crm = obj.usuario.cz08_crem
        }

        pesquisa.nomepaciente = this.nomepaciente

        Pacientes.index(pesquisa).then((result) => {
          this.pacientes = result
        }).catch((err) => {
          console.log(err)
        })
      } else {
        if (this.pacientes.length > 0) {
          this.pacientes = []
        }
      }
    },
    ficha (id, index) {
      this.$router.push({name: 'Ficha', params: {id: id}})
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/Pacientes.vue